import moment from "moment";
import { LEAGUE_ROLES } from "../constants/roles";
import AbstractEntity from "./abstractEntity";

/*
leagueObj properties:
  - abbr
  - colors
  - dateFounded - getDateFounded(): Date
  - founder (username)
  - id
  - name
  - roles ({username: roleObj})
  - seasons ({season: leagueSeasonId})
  - [slug]
*/
class League extends AbstractEntity {
  /**
   *
   * @param {object} leagueObj
   * @param {UserInfo} userInfo
   */
  constructor(leagueObj, userInfo) {
    super(leagueObj, userInfo);

    if (leagueObj) {
      this.label = this.obj.name;
      this.pathDeps = { league: this.obj };
      this.defaultPathName = "leagueHome";
    }
  }

  /**
   *
   * @returns {Date}
   */
  getDateFounded() {
    return moment(this.obj.dateFounded).toDate();
  }

  /**
   *
   * @returns {string}
   */
  getIdOrSlug() {
    return this.obj.slug || this.obj.id;
  }

  /**
   *
   * @param {string} username
   * @returns {*}
   */
  getRoleObj(username) {
    this._verifyKeyExists(this.obj.roles, username, "league.roles");
    return this.obj.roles[username];
  }

  /**
   *
   * @param {number|string} season
   * @returns {object}
   */
  getLeagueSeasonObj(season) {
    this._verifyKeyExists(this.obj.seasons, season, "league.seasons");
    return this.userInfo?.getLeagueSeasonObj(this.obj.seasons[season]);
  }

  /**
   *
   * @returns {object}
   */
  getRecentLeagueSeasonObj() {
    const seasons = Object.keys(this.obj.seasons).map((seasonStr) =>
      parseInt("" + seasonStr, 10)
    );
    const recentSeason = Math.max(...seasons);
    return this.getLeagueSeasonObj(recentSeason);
  }

  /**
   *
   * @param {string} username
   * @param {number} roleValue
   * @returns {boolean}
   */
  hasRole(username, roleValue) {
    return (
      this.obj.roles.hasOwnProperty(username) &&
      this.obj.roles[username].value <= roleValue
    );
  }

  /**
   *
   * @param {string} username
   * @returns {boolean}
   */
  hasRoleCommish(username) {
    return this.hasRole(username, LEAGUE_ROLES.COMMISH);
  }

  /**
   *
   * @param {string} username
   * @returns {boolean}
   */
  hasRoleOfficial(username) {
    return this.hasRole(username, LEAGUE_ROLES.OFFICIAL);
  }

  /**
   *
   * @param {number} season
   * @returns {boolean}
   */
  hasSeason(season) {
    try {
      this._verifyKeyExists(this.obj.seasons, season, "league.seasons");
      return true;
    } catch (err) {
      return false;
    }
  }
}

export default League;
